(function () {
  'use strict';

  function initializeTracking() {
    var input = document.getElementById('YQNum');
    var container = document.getElementById('YQContainer');
    var content = input && input.closest('.rte');
    var button = content && content.querySelector('input[type="button"]');
    if (!input || !container || !button || input.dataset.tdsTrackingReady) return;
    input.dataset.tdsTrackingReady = 'true';

    var language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var messages = {
      en: {
        label: 'Tracking number', results: 'Tracking results',
        empty: 'Please enter your tracking number.',
        invalid: 'Please enter a valid tracking number.',
        loading: 'Loading tracking information…',
        unavailable: 'Tracking is temporarily unavailable. Please try again later.',
        slow: 'Tracking is taking longer than expected. Please try again in a moment.'
      },
      es: {
        label: 'Número de seguimiento', results: 'Resultados del seguimiento',
        empty: 'Introduzca su número de seguimiento.',
        invalid: 'Introduzca un número de seguimiento válido.',
        loading: 'Cargando la información de seguimiento…',
        unavailable: 'El seguimiento no está disponible temporalmente. Vuelva a intentarlo más tarde.',
        slow: 'La consulta está tardando más de lo esperado. Vuelva a intentarlo en unos instantes.'
      },
      fr: {
        label: 'Numéro de suivi', results: 'Résultats du suivi',
        empty: 'Veuillez saisir votre numéro de suivi.',
        invalid: 'Veuillez saisir un numéro de suivi valide.',
        loading: 'Chargement des informations de suivi…',
        unavailable: 'Le suivi est temporairement indisponible. Veuillez réessayer plus tard.',
        slow: 'La recherche prend plus de temps que prévu. Veuillez réessayer dans quelques instants.'
      }
    };
    if (!messages[language]) language = 'en';
    var text = messages[language];
    var status = document.createElement('p');
    status.id = 'tds-tracking-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    container.parentNode.insertBefore(status, container);
    input.setAttribute('aria-label', text.label);
    var describedBy = input.getAttribute('aria-describedby');
    input.setAttribute('aria-describedby', (describedBy ? describedBy + ' ' : '') + status.id);

    var request = 0;
    var timeout;
    function show(message) {
      status.textContent = message;
      status.hidden = !message;
    }
    function track(event) {
      if (event) event.preventDefault();
      window.clearTimeout(timeout);
      var current = ++request;
      var number = input.value.trim();
      input.removeAttribute('aria-invalid');
      if (!number) {
        input.setAttribute('aria-invalid', 'true');
        show(text.empty);
        input.focus();
        return;
      }
      if (!/[a-z0-9]/i.test(number)) {
        input.setAttribute('aria-invalid', 'true');
        show(text.invalid);
        input.focus();
        return;
      }
      input.value = number;
      if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') {
        show(text.unavailable);
        return;
      }
      show(text.loading);
      function loaded() {
        if (current !== request) return;
        window.clearTimeout(timeout);
        show('');
      }
      timeout = window.setTimeout(function () {
        if (current === request) show(text.slow);
      }, 20000);
      try {
        window.YQV5.trackSingle({
          YQ_ContainerId: 'YQContainer', YQ_Height: 560,
          YQ_Fc: '0', YQ_Lang: language, YQ_Num: number,
          onLoaded: loaded
        });
        var frame = container.querySelector('iframe');
        if (!frame) throw new Error('Tracking frame was not created');
        frame.setAttribute('title', text.results);
        frame.addEventListener('error', function () {
          if (current !== request) return;
          window.clearTimeout(timeout);
          show(text.unavailable);
        }, { once: true });
      } catch (error) {
        window.clearTimeout(timeout);
        show(text.unavailable);
      }
    }
    button.addEventListener('click', track);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !event.isComposing && !event.repeat) track(event);
    });
    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true') {
        input.removeAttribute('aria-invalid');
        show('');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTracking, { once: true });
  } else {
    initializeTracking();
  }
}());
